import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// 分割ルーティング設定
import commonRoutes from './commonRoutes'
import studentRoutes from './studentRoutes'
import adminRoutes from './adminRoutes'
import academyRoutes from './academyRoutes'
import branchRoutes from './branchRoutes'
import errorRoutes from './errorRoutes'
import debugRoutes from './debugRoutes'

Vue.use(VueRouter)

/**
 * 通常ページ群
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
const routes: Array<RouteConfig> = []

/**
 * 分割定義したルーティング設定の追加
 */
routes.push(...commonRoutes)
routes.push(...studentRoutes)
routes.push(...adminRoutes)
routes.push(...academyRoutes)
routes.push(...branchRoutes)
routes.push(...errorRoutes)

/**
 * テスト用ページのルーティング設定 環境設定がtrueの場合のみアクセス可能
 */
if (process.env.VUE_APP_ENABLE_DEBUG_PAGE == 'true') {
  routes.push(...debugRoutes)
}

/**
 * エラー画面へのリダイレクト設定を追加(最後に行うことで優先度を下げる)
 */
routes.push({
  path: '*',
  redirect: '/error/error404',
})

/**
 * router設定
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 画面遷移前にcookieを更新する処理を設定
router.beforeResolve(async (to, from, next) => {
  // cookie有効期限を更新
  await Vue.prototype.$bcbtCookies.updateCookieExpire()

  // 処理を継続する
  next()
})

export default router
